// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Fit = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <rect fill='none' stroke={stroke} x='7.3' y='15.5' width='33.4' height='17' />
      <polyline fill='none' stroke={stroke} points='47.2 20.5 47.2 12.2 38.9 12.2' />
      <polyline fill='none' stroke={stroke} points='9.1 12.2 .8 12.2 .8 20.5' />
      <polyline fill='none' stroke={stroke} points='38.9 35.8 47.2 35.8 47.2 27.5' />
      <polyline fill='none' stroke={stroke} points='.8 27.5 .8 35.8 9.1 35.8' />
    </svg>
  );
};
